import { maxLengthValidation, numbersOnlyRules } from "@/Pages/ProfileForm";
import { useTranslation } from "react-i18next";

export const useValidation = () => {
  const { t } = useTranslation();

  return {
    maxLengthValidation: (maxLength) => maxLengthValidation(t, maxLength),
    numbersOnlyValidation: () => numbersOnlyRules(t),
  };
};
